module.exports = __webpack_public_path__ + "components/app-promo/static/intersport/7-86833b93a66712fd774b9b5cd4eb0b0a.png";